const applicationDetail = {
  titleOne: 'Our customers',
  titleTwo: 'Product application',
  titleThree: 'Product Applications and Solutions',
  titleFour: 'Industry case',
}

export default {
  title: 'Application Area',
  titleOne: 'KELK is a multi-domain fluid expert',
  contentOne: `
  In the field of petroleum refining, clean energy, metallurgy and other harsh working conditions for more than 60 years, Wuxi Kelke has defined industrial safety and performance benchmarks with cutting-edge fluid control products such as ultra-low temperature cryogenic valve and nuclear grade main steam control valve. From LNG supercritical storage and transportation to ultra-high pressure control of hydrogen energy, from intelligent metallurgical blast furnaces to environmental protection desulfurization devices, we have developed high-end control equipment and full life cycle management services according to ASME B16.34/API 6D standard for global industrial giants with 18 patents, such as multi-stage step-down labyrinth valve core and metal bellows dynamic seal. Reshape global industrial flow control standards with Chinese precision.
  `,
  applicationDetail,
}


// WEBPACK FOOTER //
// ./src/config/lang/en/applicationAreaPage.js